export { TruckAlt as default } from './TruckAlt';
